import { StyleSheet } from "@react-pdf/renderer";

export const worksheet = StyleSheet.create({
  header: {
    borderBottom: 1,
  },

  section: {
    borderTop: 1,
    borderBottom: 1,
    marginTop: 20,
    paddingTop: 5,
    paddingBottom: 5,
  },

  title: {
    fontWeight: 700,
    marginBottom: 3,
    textDecoration: "underline",
  },

  footer: {
    width: "100%",
    position: "absolute",
    fontSize: 10,
    padding: 20,
    paddingTop: 0,
    bottom: 0,
    left: 0,
  },
});
